import defaultSettings from '@/settings'
import {
  getList as getConfigList
} from '@/api/settings'

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  theme: "",
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  cuserPhone:null,
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  getConfigInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getConfigList().then(response => {
        const {
          data
        } = response
        if (!data) {
          reject('获取配置失败')
          return
        }
        const {
          cuser_phone
        } = data
        commit('CHANGE_SETTING', {
          key: "cuserPhone",
          value: cuser_phone
        })
        resolve(data)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/settings.js